<style>
  .trd-auth-shell{ min-height:78vh; display:flex; align-items:center; justify-content:center; padding:40px 16px; }
  .trd-auth-card{ width:400px; max-width:100%; padding:34px 32px 26px; border-radius:14px; text-align:left; }
  .trd-auth-logo{ width:54px; height:auto; display:block; margin-bottom:18px; border-radius:4px; }
  .trd-auth-title{ font:600 24px "Open Sans",sans-serif; margin:0 0 4px; color:rgba(0,0,0,.87); }
  .trd-auth-sub{ font:14px/1.5 "Open Sans",sans-serif; color:rgba(0,0,0,.6); margin:0 0 20px; }
  .trd-auth-form{ display:flex; flex-direction:column; }
  .trd-ff{ width:100%; }
  .trd-auth-btn{ width:100%; height:44px; font-weight:600; letter-spacing:.02em; }
  .trd-auth-foot{ text-align:center; margin:14px 0 0; }
</style>

<div class="trd-auth-shell">
  <mat-card class="trd-auth-card">
    <img class="trd-auth-logo" src="../../assets/new-home-page/images/logo.jpg" alt="TheRightDoctors"/>
    <h1 class="trd-auth-title">Reset your password</h1>
    <p class="trd-auth-sub">Enter the email linked to your account and we&rsquo;ll send you a secure reset link.</p>
    <form role="form" (ngSubmit)="login()" #ff="ngForm" novalidate class="trd-auth-form">
      <mat-form-field appearance="outline" class="trd-ff">
        <mat-label>Email</mat-label>
        <input matInput type="email" name="user_id" [(ngModel)]="model.user_id" #user_id="ngModel" required>
      </mat-form-field>
      <button mat-flat-button type="submit" class="trd-auth-btn">Send reset link</button>
    </form>
    <p class="trd-auth-foot"><a mat-button [routerLink]="['/login-page']">&larr; Back to sign in</a></p>
  </mat-card>
</div>
